import type { RouterOutputs } from '@klear/ui/lib/trpc'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { trpc } from '@klear/ui/lib/trpc'

type TraderList = RouterOutputs['trader']['list']

export function useTraders(): {
  traders: TraderList | undefined
  isLoading: boolean
  error: ReturnType<typeof trpc.trader.list.useQuery>['error']
} {
  const { user } = useAuth()

  const {
    data: traders,
    isLoading,
    error
  } = trpc.trader.list.useQuery(
    {},
    {
      enabled: !!user
    }
  )

  return {
    traders,
    isLoading,
    error
  }
}

export function useTradersWithActivity(): {
  traders: RouterOutputs['trader']['listWithActivity'] | undefined
  isLoading: boolean
  error: ReturnType<typeof trpc.trader.listWithActivity.useQuery>['error']
} {
  const { user } = useAuth()

  const {
    data: traders,
    isLoading,
    error
  } = trpc.trader.listWithActivity.useQuery(undefined, {
    enabled: !!user
  })

  return {
    traders,
    isLoading,
    error
  }
}
